import React, { useId, useState } from 'react';

/** Text field with a leading icon. The visible hint is the placeholder; the label is kept for screen readers. */
export function AuthField({ label, icon, id, children, ...inputProps }) {
  const generated = useId();
  const fieldId = id || `af-${generated.replace(/:/g, '')}`;
  return (
    <div className="auth-field">
      <label className="visually-hidden" htmlFor={fieldId}>{label}</label>
      <span className="auth-field__icon" aria-hidden="true"><i className={`bi ${icon}`} /></span>
      <input id={fieldId} className="auth-field__input" {...inputProps} />
      {children}
    </div>
  );
}

/** Password field with a show / hide toggle. */
export function PasswordField({ label = 'Password', ...props }) {
  const [shown, setShown] = useState(false);
  return (
    <AuthField label={label} icon="bi-lock" type={shown ? 'text' : 'password'} {...props}>
      <button type="button" className="auth-field__toggle" onClick={() => setShown((s) => !s)} aria-label={shown ? 'Hide password' : 'Show password'} aria-pressed={shown}>
        <i className={`bi ${shown ? 'bi-eye-slash' : 'bi-eye'}`} aria-hidden="true" />
      </button>
    </AuthField>
  );
}
